var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-tm",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M42.7 0h682.6v512H42.7z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(-40) scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M0 0h768v512H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.3 137.5c27.9 13.4 61.1 0 73.1-18.6 12.4-17.4 13.9-46.5-7.4-73.2 33 27.4 40.4 58.5 23.9 84.1-22 29.3-70.6 28.4-89.6 7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.8 69.4 5.6.1L314 73l1.7 5.6-4.7-3.3-4.5 3.3 1.5-5.5-4.5-3.5 5.6-.1L311 64zm-27.7 34.8h5.6l-4.4 3.6 1.7 5.5-4.7-3.3-4.6 3.4 1.6-5.6-4.5-3.4 5.6-.2 1.8-5.5zm1.8-27.4h5.7l-4.5 3.6 1.7 5.5-4.6-3.3-4.6 3.4 1.6-5.6-4.5-3.5 5.6-.1 1.8-5.5zm0-27.5h5.7L288 53l1.7 5.5-4.6-3.2-4.6 3.3 1.6-5.5-4.5-3.5 5.6-.1L285 44zm-30.7 34.8h5.6l-4.5 3.6 1.7 5.5-4.6-3.3-4.6 3.4 1.6-5.6-4.5-3.4 5.6-.2 1.8-5.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M47.5 0h164.6v512H47.5z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5 133.5v-3.7l6.8-9.1-1.3-1.9 4-5.4-1.3-1.9-2.7 3.7-1.4-1.8 9.6-12.8 1.4 1.8-1.4 1.8L64 108l6.8-9.2-6.9-8.9-2.7 3.4 1.4 1.9-1.4 1.8-9.6-12.8 1.4-1.8 2.7 3.6 1.4-1.8-4.1-5.5 1.3-1.8-6.8-9.2V64l9.6 12.8-1.4 1.8 4.1 5.5-2.7 3.7 2.7 3.6L64 86l9.7 13-9.7 12.6-4-5.5-2.8 3.7 2.7 3.7-4 5.4 1.3 1.9-9.6 12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.5 87.8 1.4 3.6V97H53l2.8 1.8-2.8 1.9h-4v5.4l-1.4 3.7v-22z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5 221.3v-3.7l6.8-9.1-1.3-1.9 4-5.5-1.3-1.8L53 203l-1.4-1.9 9.6-12.8 1.4 1.9-1.4 1.8 2.8 3.7 6.8-9.2-6.9-8.9-2.7 3.4 1.4 1.9-1.4 1.8-9.6-12.8L53 170l2.7 3.6 1.4-1.8-4.1-5.5 1.3-1.8-6.8-9.2v-3.6l9.6 12.8-1.4 1.8 4.1 5.5-2.7 3.6 2.7 3.7 4.1-5.5 9.7 13-9.7 12.6-4-5.5-2.8 3.7 2.7 3.6-4 5.5 1.3 1.9-9.6 12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.5 175.5 1.4 3.7v5.5H53l2.8 1.8-2.8 1.8h-4v5.5l-1.4 3.7v-22z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5 309v-3.6l6.8-9.2-1.3-1.8 4-5.5-1.3-1.8-2.7 3.6-1.4-1.8 9.6-12.8 1.4 1.8-1.4 1.9 2.8 3.7 6.8-9.2-6.9-9-2.7 3.5 1.4 1.8-1.4 1.8-9.6-12.8 1.4-1.8 2.7 3.7 1.4-1.9-4.1-5.4 1.3-1.9-6.8-9.1v-3.7l9.6 12.8-1.4 1.9 4.1 5.4-2.7 3.7 2.7 3.7 4.2-5.5 9.6 13-9.7 12.6-4-5.5-2.8 3.6 2.7 3.7-4 5.5 1.3 1.8-9.6 12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5 263.3 49 267v5.5h4l2.8 1.8L53 276h-4v5.5l-1.4 3.7v-22z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5 391.3v-3.7l6.8-9.1-1.3-1.8 4-5.5-1.3-1.8L53 373l-1.4-1.8 9.6-12.8 1.4 1.8-1.4 1.8 2.8 3.7 6.8-9.1-6.9-9-2.7 3.5 1.4 1.8-1.4 1.8-9.6-12.8 1.4-1.8 2.7 3.7 1.4-1.9-4.1-5.5 1.3-1.8-6.8-9.1v-3.7l9.6 12.8-1.4 1.8 4.1 5.5-2.7 3.7 2.7 3.6 4.2-5.4 9.6 13-9.7 12.6-4-5.5-2.8 3.6 2.7 3.7-4 5.5 1.3 1.8-9.6 12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.5 345.6 1.4 3.6v5.5H53l2.8 1.9-2.8 1.8h-4v5.5l-1.4 3.6v-22z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.1 133.5v-3.7l-6.8-9.1 1.4-1.9-4.1-5.4 1.3-1.9 2.8 3.7 1.4-1.8-9.6-12.8-1.4 1.8 1.4 1.8-2.9 3.7-6.7-9.2 6.8-8.9 2.8 3.4-1.4 1.9 1.3 1.8 9.6-12.8-1.3-1.8-2.8 3.6-1.3-1.8 4-5.5-1.3-1.8 6.8-9.2V64l-9.5 12.8 1.3 1.8-4 5.5 2.7 3.7-2.8 3.6-4.1-5.5-9.7 13 9.7 12.6 4.1-5.5 2.8 3.7-2.8 3.7 4.1 5.4-1.3 1.9 9.5 12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.1 87.8-1.4 3.6V97h-4l-2.8 1.8 2.7 1.9h4.1v5.4l1.4 3.7v-22z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6 221.3v-3.7l-6.8-9.1 1.3-1.9-4-5.5 1.3-1.8 2.7 3.7 1.4-1.9-9.6-12.8-1.4 1.9 1.4 1.8-2.8 3.7-6.8-9.2 6.9-8.9 2.7 3.4-1.4 1.8 1.4 1.9 9.6-12.8-1.4-1.9-2.7 3.7-1.4-1.8 4.1-5.5-1.3-1.8 6.8-9.2v-3.6l-9.6 12.8 1.4 1.8-4.1 5.5 2.7 3.6-2.7 3.7-4.1-5.5-9.7 13 9.7 12.6 4-5.5 2.8 3.7-2.7 3.6 4 5.5-1.3 1.8 9.6 12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.6 175.5-1.4 3.7v5.5H207l-2.8 1.8 2.8 1.8h4v5.5l1.5 3.7v-22z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.1 309v-3.6l-6.8-9.2 1.4-1.8-4.1-5.5 1.3-1.8 2.8 3.6 1.4-1.8-9.6-12.8-1.4 1.8 1.4 1.9-2.9 3.7-6.7-9.2 6.8-9 2.8 3.5-1.4 1.8 1.3 1.8 9.6-12.8-1.3-1.8-2.8 3.7-1.3-1.9 4-5.4-1.3-1.9 6.8-9.1v-3.7l-9.5 12.8 1.3 1.9-4 5.4 2.7 3.7-2.8 3.7-4.1-5.5-9.7 13 9.7 12.6 4.1-5.5 2.8 3.6-2.8 3.7 4.1 5.5-1.3 1.8L212 309z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.1 263.3-1.4 3.7v5.5h-4l-2.8 1.8 2.7 1.8h4.1v5.5l1.4 3.7v-22z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.1 391.3v-3.7l-6.8-9.1 1.4-1.8-4.1-5.5 1.3-1.8 2.8 3.6 1.4-1.8-9.6-12.8-1.4 1.8 1.4 1.8-2.9 3.7-6.7-9.1 6.8-9 2.8 3.5-1.4 1.8 1.3 1.8L208 342l-1.3-1.8-2.8 3.7-1.3-1.9 4-5.5-1.3-1.8 6.8-9.1v-3.7l-9.5 12.8 1.3 1.8-4 5.5 2.7 3.7-2.8 3.6-4.1-5.4-9.7 13 9.7 12.6 4.1-5.5 2.8 3.6-2.8 3.7 4.1 5.5-1.3 1.8 9.5 12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.1 345.6-1.4 3.6v5.5h-4l-2.8 1.9 2.7 1.8h4.1v5.5l1.4 3.6v-22z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M47.5 34.7v-3.6l6.8-9.2-1.3-1.8 4-5.5-1.3-1.8-2.7 3.7-1.4-1.9 9.6-12.8 1.4 1.9-1.4 1.8L64 9.2 70.8 0h2.8L64 12.8l-4.2-5.5-2.7 3.7 2.7 3.6-4 5.5L57 22l-9.5 12.8zm0-34.7h8.3L53 1.8h-4v5.5L47.4 11V0zm164.6 34.7v-3.6l-6.8-9.2 1.4-1.8-4.1-5.5 1.3-1.8 2.8 3.7 1.3-1.9-9.6-12.8-1.3 1.9 1.3 1.8-2.8 3.7-6.8-9.2H186l9.7 12.8 4.1-5.5 2.8 3.7-2.8 3.6 4.1 5.5-1.3 1.8 9.5 12.8zm0-34.7h-8.2l2.7 1.8h4.1v5.5l1.4 3.7V0zM116.1 504.7s6-10.4 20.8-13.5c14.9-3.2 17.5 6.9 26 6.9s22-7 22-7-13.5 13.3-24 13c-10.3-.3-13.8-7-24.5-6-10.6 1-20.3 6.9-20.3 6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M144.8 504.7s-5.9-10.4-20.7-13.5c-15-3.2-17.5 6.9-26 6.9s-22-7-22-7 13.5 13.3 23.9 13c10.4-.3 14-7 24.5-6 10.7 1 20.3 6.9 20.3 6.6z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.2 487.5c-1.3-2.7-4.6-14.7-2.9-16.2 2.7-1 9.7 11.3 9 22.2-4.6 2.5-20-1-19.9-4.2 1.1-4.5 9.9-3 13.8-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8 477c-.8-3-2.2-15.6-.2-16.6 2.7-.2 7.6 13.7 5.3 24.2-4.9 1.2-19.5-6.5-18.8-9.6 1.8-4 10-.2 13.7 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2 465.4c-.6-3.2-.8-16 1.2-16.6 2.7.2 6.4 14.8 3.2 24.9-5 .4-18.8-9.6-17.8-12.5 2-3.8 10 1.3 13.4 4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2 453c-.2-3.3 1-16 3.1-16.2 2.7.7 4.6 15.9.2 25.2-4.9-.6-17.4-13.3-16-16 2.4-3.3 9.7 3.4 12.7 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 439.9c.2-3.3 2.8-15.5 4.9-15.4 2.5 1.3 2.8 16.6-2.5 25-4.8-1.6-15.9-16.5-14.3-19 2.9-2.8 9.3 5.3 12 9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2 425c-.3 13-2.7 13.2-7 3.6-2-3.7-2.2-18.7-.5-19.3 2.5 0 7.4 10.7 7.5 15.7z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164 489c1.3-2.8 4.6-14.8 2.9-16.3-2.7-1-9.6 11.2-9 22.2 4.6 2.5 20.1-1 19.9-4.2-1.1-4.5-9.8-3-13.8-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.4 478.4c.9-3 2.2-15.6.3-16.6-2.7-.2-7.7 13.6-5.3 24.2 4.8 1.2 19.5-6.5 18.7-9.6-1.7-4.1-10-.2-13.7 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 466.8c.6-3.2.8-16-1.2-16.6-2.7.2-6.4 14.7-3.1 24.8 5 .4 18.8-9.5 17.8-12.5-2.2-3.8-10 1.4-13.5 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 454.3c.2-3.2-1-15.9-3.1-16.1-2.7.7-4.6 15.9-.2 25.2 5-.6 17.4-13.3 16.1-16-2.5-3.4-9.7 3.4-12.8 6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.2 441.2c-.1-3.2-2.8-15.5-4.8-15.3-2.6 1.2-2.9 16.6 2.5 25 4.8-1.6 15.8-16.5 14.2-19-2.9-2.8-9.3 5.3-12 9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 426.4c.4 13 2.7 13.1 7 3.5 2-3.6 2.2-18.7.5-19.2-2.5 0-7.4 10.7-7.5 15.7z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99985 0 0 1.26515 188.3 -77)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M-3.5 290.6H-9v3.5h-5.3v3.5h-21.2l-3.6 3.6 1.8 1.8h8.9l1.7-1.8h-8.8l1.7-1.8h12.4l-5.3 5.3H-39l-3.5-1.7-3.6 1.7h-12.4l-5.3-5.3h12.4l1.8 1.8h-8.9l1.8 1.8h8.9l1.7-1.8-3.5-3.6h-19.5v-3.5h-5.3v-3.5h-5.3v-16h5.3v-3.5h5.3v-3.6h19.5l3.5-3.5-1.7-1.8h-8.9l-1.8 1.8h8.9l-1.8 1.7h-12.4l5.3-5.3H-46l3.6 1.8 3.5-1.8h12.4l5.3 5.3h-12.4l-1.7-1.7h8.8l-1.8-1.8h-8.8L-39 264l3.6 3.5h21.2v3.6h5.3v3.5h5.4v16z",
    transform: "matrix(1.4884 0 0 1.24 3.5 -39.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    stroke: "#faae29",
    strokeWidth: 1.4,
    d: "M375.6 499.7v24.8h10.6v7h10.6v7h35.5l14.2 10.7 14.1-10.6h39v-7l10.6-.1v-7H521v-24.9h-10.7v-7h-10.6v-7.2h-39l-14.1-10.6-14.2 10.6h-35.5v7.2h-10.6v7h-10.6z",
    transform: "matrix(.74419 0 0 .62 -392 -6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m-75.6 296.6-15.8 11v-11h15.8zm31.6 0 15.9 11v-11H-44zm-31.6 28.6-15.8-11v11h15.8zm31.6 0 15.9-11v11H-44zm5.3-22-5.3 4.4h10.6l-5.3-4.4zm-42.2 0-5.2 4.4h10.5l-5.3-4.4zm0 15.4-5.2-4.4h10.5l-5.3 4.4zm42.2 0-5.3-4.4h10.6l-5.3 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "m-59.8 329.6-5.3-4.4h10.6l-5.3 4.4zm0-22-5.3-4.4h10.6l-5.3 4.4zm0-15.4-5.3 4.5h10.6l-5.3-4.5zm0 22-5.3 4.4h10.6l-5.3-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M467.7 506.7H482v3.5h-14.2z",
    transform: "matrix(.74419 0 0 .62 -392 -6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M414.6 510.2h7v3.6h-7zm56.7 0h7v3.6h-7z",
    transform: "matrix(.74419 0 0 .62 -392 -6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#900",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M439.4 489h14.1v3.5h-14.1zm0 7h14.1v3.6h-14.1z",
    transform: "matrix(.74419 0 0 .62 -392 -6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#900",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M435.8 492.5h21.3v3.6h-21.3zm3.6 32h14.1v3.4h-14.1zm0 7h14.1v3.5h-14.1zm-3.6-3.5h21.3v3.5h-21.3z",
    transform: "matrix(.74419 0 0 .62 -392 -6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M467.7 513.8H482v3.5h-14.2zm-56.7-7.1h14.2v3.5H411zm0 7h14.2v3.6H411zm-3.5-3.5h7v3.6h-7zm14.2 0h7v3.6h-7zm42.5 0h7v3.6h-7zm14.2 0h7v3.6h-7z",
    transform: "matrix(.74419 0 0 .62 -392 -6.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -374.1 -39)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -367.6 -39)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -361 -39)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -371.5 -41.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -363.7 -41.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -371.6 -36.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -363.7 -36.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -353.2 -50)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -346.6 -50)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -340 -50)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -350.5 -52.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -342.7 -52.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -350.6 -47.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -342.7 -47.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -374.2 -60.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -367.6 -60.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -361 -61)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -371.6 -63.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -363.7 -63.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -371.6 -58.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -363.7 -58.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -395.3 -49.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -388.7 -49.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -382.1 -49.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -392.6 -52)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -384.8 -52)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -392.7 -47.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -384.8 -47.6)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m138.9 255.8 4.5-2.2 4.6 2.2h-9.1zm-13.6 0 4.5-2.2 4.6 2.2h-9.1zm-13.6 0 4.5-2.2 4.6 2.2h-9.1zm27.2-49 4.5 2.2 4.6-2.1h-9.1zm-13.6 0 4.5 2.2 4.6-2.1h-9.1zm-13.6 0 4.5 2.2 4.6-2.1h-9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "m135.1 262.1-5.3 4.3-5.3-4.3-5.3 4.3-5.3-4.3v2.2l3.6 2-1.8 2.2v2.1h1.8l1.7-2 1.8 2h1.8v-2l-1.8-2.2 3.5-2.1 3.6 2-1.8 2.2v2.1h1.8l1.7-2 1.8 2h1.7v-2l-1.7-2.2 3.5-2.1 3.5 2-1.7 2.2v2.1h1.7l1.8-2 1.8 2h1.7v-2l-1.7-2.2 3.5-2.1V262l-5.3 4.3-5.3-4.3zm0-61.6-5.3-4.3-5.3 4.3-5.3-4.3-5.3 4.3v-2.1l3.6-2.2-1.8-2V192h1.8l1.7 2.1 1.8-2.1h1.8v2.1l-1.8 2.2 3.5 2 3.6-2-1.8-2.2V192h1.8l1.7 2.1 1.8-2.1h1.7v2.1l-1.7 2.2 3.5 2 3.5-2-1.7-2.2V192h1.7l1.8 2.1 1.8-2.1h1.7v2.1l-1.7 2.2 3.5 2v2.2l-5.3-4.3-5.3 4.3zm40 35.4 5.8-4.6-5.7-4.6 5.7-4.6-5.7-4.6h2.8l2.9 3 2.8-1.5h2.8v1.6l-2.8 1.5 2.8 1.5v1.6h-2.8l-2.8-1.6-2.9 3.1 2.9 3 2.8-1.4h2.8v1.5l-2.8 1.5 2.8 1.5v1.6h-2.8l-2.8-1.6-2.9 3.1 2.9 3 2.8-1.5h2.8v1.6l-2.8 1.5 2.8 1.6v1.5h-2.8l-2.8-1.5-2.9 3h-2.8l5.7-4.6-5.7-4.6zm-90.6 0-5.7-4.6 5.7-4.6-5.7-4.6 5.7-4.6h-2.9l-2.8 3L76 219h-3v1.6l3 1.4-2.9 1.5v1.6H76l2.8-1.6 2.8 3.1-2.8 3-2.8-1.4h-3v1.5l2.9 1.5-2.9 1.5v1.6h3l2.8-1.6 2.8 3.1-2.8 3.1-2.8-1.5h-3v1.5l2.9 1.5L73 242v1.5h3l2.8-1.5 2.8 3h2.9l-5.7-4.6 5.7-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-26.6 214.4h1.8v1.7h-1.8zm-1.8 1.7h1.8v1.8h-1.7zm-8.8 8.9h1.8v1.8h-1.8zm1.8-1.8h1.7v1.8h-1.7zm-58.5 0h1.8v1.8H-94zm-8.9-8.8h1.8v1.7h-1.8zm1.8 1.7h1.8v1.8h-1.8zm0-39h1.8v1.8h-1.8zm-1.8 1.8h1.8v1.8h-1.8zm10.7-10.6h1.7v1.8H-92zm-1.8 1.8h1.8v1.8H-94zm56.7-1.8h1.8v1.8h-1.8zm1.8 1.8h1.7v1.8h-1.7zm7 7h1.8v1.8h-1.7zm1.8 1.9h1.8v1.7h-1.8zM-92 225h1.7v1.8H-92z",
    transform: "matrix(1.2798 0 0 1.1995 211.4 -5.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M122.9 231.3h-6.7v-4.2h4.5v-3.9h4.4v-3.6h4.5v4.5c-3.7 0-6.7 3-6.7 7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M136.3 231.3h6.7v-4.2h-4.5v-3.9H134v-3.6h-4.4v4.5c3.7 0 6.7 3 6.7 7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M136.3 231.3h6.7v4.2h-4.5v3.9H134v3.6h-4.4v-4.5c3.7 0 6.7-3 6.7-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M122.9 231.3h-6.7v4.2h4.5v3.9h4.4v3.6h4.5v-4.5c-3.7 0-6.7-3-6.7-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M136.3 231.3h-6.7v-7.2c3.7 0 6.7 3.3 6.7 7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M136.3 231.3h-6.7v7.2c3.7 0 6.7-3.2 6.7-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M122.9 231.3h6.7v7.2c-3.7 0-6.7-3.2-6.7-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M122.9 231.3h6.7v-7.2c-3.7 0-6.7 3.3-6.7 7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "m136.6 257.9-6.8-4.3-6.8 4.3-6.8-4.3-6.8 4.3v-2.1l4.5-2.2-2.2-2.1v-2.1h2.2l2.3 2.1 2.3-2.1h2.3v2.1l-2.3 2.1 4.5 2.2 4.6-2.2-2.3-2.1v-2.1h2.3l2.2 2.1 2.3-2.1h2.3v2.1l-2.3 2.1 4.5 2.2 4.6-2.2-2.3-2.1v-2.1h2.3l2.2 2.1 2.3-2.1h2.3v2.1l-2.3 2.1 4.5 2.2v2l-6.8-4.2-6.8 4.3zm0-53.1-6.8 4.2-6.8-4.2-6.8 4.2-6.8-4.2v2l4.5 2.2-2.2 2.1v2.2h2.2l2.3-2.2 2.3 2.2h2.3V211l-2.3-2 4.5-2.2 4.6 2.1-2.3 2.1v2.2h2.3l2.2-2.2 2.3 2.2h2.3V211l-2.3-2 4.5-2.2 4.6 2.1-2.3 2.1v2.2h2.3l2.2-2.2 2.3 2.2h2.3V211l-2.3-2 4.5-2.2v-2.1l-6.8 4.2-6.8-4.2zm25 31.8-3.4-5.3 3.4-5.3-3.4-5.3 3.4-5.3h-1.7l-1.7 3.5-1.7-1.8h-1.7v1.8l1.7 1.8-1.7 1.8v1.7h1.7l1.7-1.7 1.7 3.5-1.7 3.5-1.7-1.7h-1.7v1.7l1.7 1.8-1.7 1.8v1.8h1.7l1.7-1.8 1.7 3.5-1.7 3.6-1.7-1.8h-1.7v1.8l1.7 1.7-1.7 1.8v1.8h1.7l1.7-1.8 1.7 3.6h1.7l-3.4-5.4 3.4-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m-101 177.2-7 7v26.6l7 7.1h32l7-7v-26.6l-7.1-7.1H-101zm-1.8-5.4-17.7 17.8v16l17.8 17.6h35.4l17.7-17.7v-16l-17.7-17.7h-35.4z",
    transform: "matrix(1.2798 0 0 1.1995 238.7 -5.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(1.02384 0 0 .79966 215 140.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(1.02384 0 0 -.79966 215 322.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(1.02384 0 0 -.79966 229.6 322.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(1.02384 0 0 .79966 229.6 140.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(1.02384 0 0 -.79966 207.8 322.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(1.02384 0 0 -.79966 222.3 322.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(1.02384 0 0 -.79966 236.8 322.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-104.5 180.7 3.5-3.5h-3.5v3.5z",
    transform: "matrix(1.9196 0 0 -1.7991 303.3 576.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "m98 236.6 3.5-5.3L98 226l3.4-5.3-3.4-5.3h1.7l1.7 3.5 1.7-1.8h1.7v1.8l-1.7 1.8 1.7 1.8v1.7h-1.7l-1.7-1.7-1.7 3.5 1.7 3.5 1.7-1.7h1.7v1.7l-1.7 1.8 1.7 1.8v1.8h-1.7l-1.7-1.8-1.7 3.5 1.7 3.6 1.7-1.8h1.7v1.8l-1.7 1.7 1.7 1.8v1.8h-1.7l-1.7-1.8-1.7 3.6H98l3.4-5.4-3.4-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(1.2798 0 0 1.07958 261.3 59.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m-99.2 180.7-3.6 3.6v26.5l3.6 3.6h-5.3v-33.7h5.3z",
    transform: "matrix(1.2798 0 0 1.1995 229.6 -5.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(1.02384 0 0 .79966 207.8 140.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(1.02384 0 0 .79966 222.3 140.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(1.02384 0 0 .79966 236.8 140.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m-99.2 180.7-3.6 3.6v26.5l3.6 3.6h-5.3v-33.7h5.3z",
    transform: "matrix(-1.2798 0 0 1.1995 30 -5.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-104.5 180.7 3.5-3.5h-3.5v3.5z",
    transform: "matrix(-1.9196 0 0 -1.7991 -43.6 576.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-104.5 180.7 3.5-3.5h-3.5v3.5z",
    transform: "matrix(-1.9196 0 0 1.7991 -43.6 -114)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-104.5 180.7 3.5-3.5h-3.5v3.5z",
    transform: "matrix(1.9196 0 0 1.7991 303.3 -114)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m-101 177.2-7 7v26.6l7 7.1h32l7-7v-26.6l-7.1-7.1H-101zm0-1.8-8.8 8.8v26.6l8.8 8.9h32l8.8-8.9v-26.6l-8.9-8.8H-101z",
    transform: "matrix(1.2798 0 0 1.1995 238.7 -5.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(1.2798 0 0 1.07965 261.3 63)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(1.2798 0 0 1.07958 261.3 66.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(1.2798 0 0 1.07965 261.3 70.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(1.2798 0 0 1.07965 261.3 55.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(-1.2798 0 0 1.07958 -1.7 59.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(-1.2798 0 0 1.07965 -1.7 63)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(-1.2798 0 0 1.07958 -1.7 66.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(-1.2798 0 0 1.07965 -1.7 70.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(-1.2798 0 0 1.07965 -1.7 55.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#970000",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-101 179v37h8.9v8.9h56.7V216h8.8v-37h-8.8v-8.8h-56.7v8.8h-8.9zm1.8 1.7v33.7h8.8v8.8h53.2v-8.8h8.9v-33.7h-8.9V172h-53.2v8.8h-8.8z",
    transform: "matrix(1.2798 0 0 1.1995 211.4 -5.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-28.4 69.1-5.3-7.1v-5.3l-5.3-5.3h-10.6l-8.9-5.3h-28.3l-8.9 5.3h-10.6l-5.3 5.3V62l-5.3 7v14.3l5.3 7v5.4l5.3 5.3h10.6l8.9 5.3h28.3l8.9-5.3H-39l5.4-5.3v-5.3l5.3-7.1V69z",
    transform: "matrix(1.2798 0 0 1.1535 222.8 -36.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M75.4 51.2v6.1l6.8 8.2v6.1l6.8 6.2h13.6l11.4 6h15.8V51.3H75.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m110.7 65.5-8.3 5.3h-5l1.7 1.7-3.3 3.5 1.7 1.8 5-1.8 1.6 1.8.7-4.7 9.2-5.6-3.3-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m101.6 61.4-8.3 5.3h-4.9l1.6 1.7-3.2 3.5 1.6 1.8 5-1.8 1.6 1.8.8-4.7 9.1-5.5-3.3-2zm-4.5-8.2-8.3 5.3h-5l1.7 1.8-3.3 3.5 1.7 1.7 5-1.8 1.6 1.8.7-4.7 9.2-5.5-3.3-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M184.2 51.2v-6.1l-6.8-8.2v-6.1l-6.8-6.2H157l-11.3-6.1h-15.9v32.7h54.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M129.8 83.9h-4.2l-4.8-4.1H113l-4.2-2 2.1-2 4.2 2h4.2l4.2-6.2 6.3 2v4.2h-6.3l6.3 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M75.4 51.2v-6.1l6.8-8.2v-6.1l6.8-6.2h13.6l11.4-6.1h15.8v32.7H75.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M129.8 18.5h-4.2l-4.8 4H113l-4.2 2.1 2.1 2 4.2-2h4.2l4.2 6.2 6.3-2v-4.2h-6.3l6.3-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M129.8 18.5h4.2l4.9 4h7.7l4.2 2.1-2 2-4.3-2h-4.2l-4.2 6.2-6.3-2v-4.2h6.3l-6.3-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M184.2 51.2v6.1l-6.8 8.2v6.1l-6.8 6.2H157l-11.3 6h-15.9V51.3h54.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M129.8 83.9h4.2l4.9-4.1h7.7l4.2-2-2-2-4.3 2h-4.2l-4.2-6.2-6.3 2v4.2h6.3l-6.3 6zm-28.2-43-8.3-5.2h-4.9L90 34l-3.2-3.5 1.6-1.8 5 1.8 1.6-1.8.8 4.7 9.1 5.5-3.3 2zm47.4-4 8.2-5.3h5l-1.7-1.7 3.3-3.5-1.6-1.8-5 1.8-1.6-1.8-.8 4.7-9.1 5.6 3.3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m110.7 36.9-8.3-5.3h-5l1.7-1.7-3.3-3.5 1.7-1.8 5 1.8 1.6-1.8.7 4.7 9.2 5.5-3.3 2zM97 49.2l-8.3-5.3h-5l1.7-1.8-3.3-3.5L84 37l5 1.8 1.6-1.8.7 4.7 9.2 5.5-3.3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M79.5 51.2h2l2.1 2 2.1-2h44.1v28.6h-2l2 2V84l-6.3-6.1v-2h2.1v2h2.1v-2l-17-9H96.3v-9L90 53.4h-4.2l-2.1 2 2 2h-2l-4.2-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M79.5 51.2h2l2.1-2 2.1 2h44.1V22.6h-2l2-2v-2.1l-6.3 6.1v2h2.1v-2h2.1v2l-17 9.1H96.3v8.9L90 49.2h-4.2l-2.1-2 2-2.1h-2l-4.2 6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M89 51.2h40.8v24.5l-18.1-10.2H98.1v-8.2l-9-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m158 41 8.3-5.3h5l-1.7-1.7 3.3-3.5-1.6-1.8-5 1.8-1.6-1.8-.8 4.7-9.1 5.5 3.2 2zm4.6 8.2 8.3-5.3h4.9l-1.7-1.8 3.3-3.5-1.6-1.7-5 1.8-1.6-1.8-.8 4.7-9.1 5.5 3.3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M180.2 51.2h-2.1l-2.1-2-2.1 2h-44.1V22.6h2.1l-2.1-2v-2.1l6.3 6.1v2H134v-2h-2.1v2l17 9.1h14.4v8.9l6.4 4.6h4.2l2-2-2-2.1h2l4.3 6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M170.6 51.2h-40.8V26.7L148 36.9h13.6v8.2l9.1 6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m149 65.5 8.2 5.3h5l-1.7 1.7 3.3 3.5-1.6 1.8-5-1.8-1.6 1.8-.8-4.7-9.1-5.6 3.3-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m158 61.4 8.3 5.3h5l-1.7 1.7 3.3 3.5-1.6 1.8-5-1.8-1.6 1.8-.8-4.7-9.1-5.5 3.2-2zm4.6-8.2 8.3 5.3h4.9l-1.7 1.7 3.3 3.5-1.6 1.8-5-1.8-1.6 1.8-.8-4.7-9.1-5.5 3.3-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M180.2 51.2h-2.1l-2.1 2-2.1-2h-44.1v28.6h2.1l-2.1 2V84l6.3-6.1v-2H134v2h-2.1v-2l17-9h14.4v-9l6.4-4.5h4.2l2 2-2 2h2l4.3-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M170.6 51.2h-40.8v24.5L148 65.5h13.6v-8.2l9.1-6.1zm-81.6 0h40.8V26.7l-18.1 10.2H98.1v8.2l-9 6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m134.3 51.2 11.4-6.1h6.8l-2.3-2 4.6-4.2-2.3-2-6.8 2-2.3-2-1 5.5-12.6 6.4 4.5 2.4zm-9 0L114 57.3h-6.8l2.2 2-4.5 4.2 2.3 2 6.8-2 2.2 2 1-5.5 12.6-6.4-4.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M125.3 51.2 114 45.1h-6.8l2.3-2-4.5-4.2 2.3-2 6.8 2 2.2-2 1 5.5 12.6 6.4-4.5 2.4zm9 0 11.4 6.1h6.8l-2.3 2 4.6 4.2-2.3 2-6.8-2-2.3 2-1-5.5-12.6-6.4 4.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M116.2 51.2 129.8 41l13.6 10.2-13.6 10.2-13.6-10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m85.7 55.3 2.1 2-2 2h-2.2l-6.3-8.1h2.1l4.2 6.1h2.1l-2-2 2-2H90v2h-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m85.7 47.1 2.1-2-2-2h-2.2l-6.3 8.1h2.1l4.2-6.1h2.1l-2 2 2 2H90v-2h-4.2zm88.2 8.2-2 2 2 2h2.1l6.3-8.1h-2l-4.3 6.1h-2l2-2-2-2h-4.3v2h4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m174 47.1-2.2-2 2.1-2h2.1l6.3 8.1h-2l-4.3-6.1h-2l2 2-2 2h-4.3v-2h4.2zm-46.3-4h4.2v16.3h-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M121.4 47.1h16.8v8.2h-16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m333 170-10.6 5.4v8.8l10.7 5.4h10.6l10.6-5.4v-8.8l-10.6-5.3h-10.6z",
    transform: "matrix(3.555 0 0 3.847 -1073.2 -292.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M87.2 396.3h2.2V392H94v4.2h2.3v-9.8H94v4.2h-4.5v-4.2h-2.3v9.8zm57.9 32.6h2.3v-4.2h4.5v4.2h2.3V419H152v4.2h-4.6V419h-2.2v9.8zm-36.6-49h2.3v-4.1h4.6v4.2h2.2v-9.8h-2.2v4.2h-4.6v-4.2h-2.3v9.8zm33.5 0h2.3v-4.1h4.6v4.2h2.3v-9.8h-2.3v4.2h-4.6v-4.2H142v9.8zm21.4 16.4h2.2V392h4.6v4.2h2.3v-9.8h-2.3v4.2h-4.6v-4.2h-2.2v9.8zm0 16.3h2.2v-4.2h4.6v4.2h2.3v-9.8h-2.3v4.2h-4.6v-4.2h-2.2v9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M129.8 435.4v-35.9h54.9v16.3L148 435.4h-18.3zm0-71.7v35.8H75v-16.3l36.5-19.5h18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M129.8 363.7v35.8h54.9v-16.3L148 363.7h-18.3zm0 71.7v-35.9H75v16.3l36.5 19.6h18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M-177.2 368.5h21.3l-21.3-10.6v10.6zm24.8-1.8v17.7H-186v-14.1h-7.1l-8.9-5.3v-12.4l5.4-5.4h-7.1V365h-1.8v-19.5h17.7l35.4 21.2z",
    transform: "matrix(1.0321 0 0 .92 342 45.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M111.5 388.1V411h5.5l12.8 6.6 12.8-6.6h5.5v-22.8h-5.5l-12.8-6.5-12.8 6.5h-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M-177.2 368.5h21.3l-21.3-10.6v10.6zm24.8-1.8v17.7H-186v-14.1h-7.1l-8.9-5.3v-12.4l5.4-5.4h-7.1V365h-1.8v-19.5h17.7l35.4 21.2z",
    transform: "matrix(-1.0321 0 0 -.92 -82.3 753.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M-177.2 368.5h21.3l-21.3-10.6v10.6zm24.8-1.8v17.7H-186v-14.1h-7.1l-8.9-5.3v-12.4l5.4-5.4h-7.1V365h-1.8v-19.5h17.7l35.4 21.2z",
    transform: "matrix(-1.0321 0 0 .92 -82.3 45.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M-177.2 368.5h21.3l-21.3-10.6v10.6zm24.8-1.8v17.7H-186v-14.1h-7.1l-8.9-5.3v-12.4l5.4-5.4h-7.1V365h-1.8v-19.5h17.7l35.4 21.2z",
    transform: "matrix(1.0321 0 0 -.92 342 753.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M86 412.6h2.2v-5h4.6v5h2.3v-11.4h-2.3v4.9h-4.6v-5H86v11.5zm21.9 16.3h2.3v-5h4.5v5h2.3v-11.4h-2.3v4.9h-4.5v-5h-2.3V429zm-22-42.4h2.3v4.9h4.6v-5h2.3V398h-2.3v-5h-4.6v4.9H86v-11.4zm22-16.3h2.3v4.9h4.5v-5h2.3v11.5h-2.3v-4.9h-4.5v5h-2.3v-11.5zm34.7 58.7h2.3v-5h4.6v5h2.3v-11.4h-2.3v4.9h-4.6v-5h-2.3V429zm22-31h2.3V393h4.5v5h2.3v-11.5h-2.3v4.9H167v-5h-2.3V398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M142.6 428.9h2.3v-5h4.6v5h2.3v-11.4h-2.3v4.9h-4.6v-5h-2.3V429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M142.6 428.9h2.3v-5h4.6v5h2.3v-11.4h-2.3v4.9h-4.6v-5h-2.3V429zm22-16.3h2.3v-5h4.5v5h2.3v-11.4h-2.3v4.8H167v-4.9h-2.3v11.5zm-22-31h2.3v-4.9h4.6v5h2.3v-11.5h-2.3v4.9h-4.6v-5h-2.3v11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m131.7 399.5 7.3-6h3.6v3H139v1.5h5.5v-5.9H139v-4.5h-7.3v4.5h1.8v-3h3.6v3l-7.3 6-7.3-6v-3h3.7v3h1.8v-4.5h-7.3v4.5h-5.5v6h5.5v-1.5H117v-3h3.7l7.3 6-7.3 5.9H117v-3h3.7V401h-5.5v6h5.5v4.4h7.3V407h-1.8v3h-3.7v-3l7.3-6 7.3 6v3h-3.6v-3h-1.8v4.4h7.3V407h5.5v-6H139v1.5h3.6v3H139l-7.3-6z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0321 0 0 .95838 204.8 18.2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m-122.3 134.3 3.4-3.8h20.6l15.4-16.7h20.6l15.4 16.8h20.6l3.4 3.7-3.4 3.7H-47l-15.4 16.8H-83L-98.3 138H-119l-3.4-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m372 391.5 2-2h22.8l17.1-19.4h19l17.2 19.5h22.8l1.9 2-1.9 1.9h-22.8L434.8 411H412l-15.2-17.5h-22.9l-1.9-2z",
    transform: "matrix(.93104 0 0 .90908 -466.9 -221.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "m-64 136.2 6.8 7.4-3.4 3.7-1.8-1.8H-64v1.8l1.7 1.9h3.5l3.4-3.7v-3.8l-6.9-7.4 6.9-7.5v-3.7l-3.4-3.7h-3.5l-1.7 1.8v1.9h1.7l1.8-1.9 3.4 3.8-6.9 7.4-6.8-7.4 6.8-7.5v-1.9h-1.7l-6.8 7.5-6.9-7.5h-1.7v1.9l6.8 7.5-6.8 7.4-6.9-7.4 3.5-3.8 1.7 1.9h1.7v-1.9l-1.7-1.8h-3.5l-3.4 3.7v3.7l6.9 7.5-6.9 7.4v3.8l3.4 3.7h3.5l1.7-1.9v-1.8H-83l-1.7 1.8-3.5-3.7 6.9-7.4 6.8 7.4-6.8 7.5v1.8h1.7l6.9-7.4 6.8 7.4h1.7v-1.8l-6.8-7.5 6.8-7.4zm-8.6-9.4-6.9 7.5 6.9 7.4 6.8-7.4-6.8-7.5zm-10.3 28v15l1.7-2 1.7 2 1.7-2 1.7 2 1.8-2 1.7 2 1.7-2 1.7 2 1.7-2 1.7 2 1.7-2 1.8 2v-15H-83zm20.6-41v-15l-1.8 2-1.7-2-1.7 2-1.7-2-1.7 2-1.7-2-1.8 2-1.7-2-1.7 2-1.7-2-1.7 2-1.7-2v15h20.6zm29 16.8v-15l-1.6 2-1.7-2-1.7 2-1.8-2-1.7 2-1.7-2-1.7 2-1.7-2v15h13.7zm-65 0v-15l-1.8 2-1.7-2-1.7 2-1.7-2-1.7 2-1.7-2-1.8 2-1.7-2v15h13.7zm65.1 7.4v15l-1.7-2-1.7 2-1.7-2-1.8 2-1.7-2-1.7 2-1.7-2-1.7 2v-15h13.7zm-65.2 0v15l-1.7-2-1.7 2-1.7-2-1.7 2-1.7-2-1.7 2-1.8-2-1.7 2v-15h13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M-62.4 154.8v9.3l1.8-1.9 1.7 2 1.7-2 1.7 2 1.7-2 1.7 2 1.8-2 1.7 2 1.7-2V138l-15.5 16.8zm-20.5 0v9.3l-1.8-1.9-1.7 2-1.7-2-1.7 2-1.7-2-1.7 2-1.7-2-1.7 2-1.8-2V138l15.5 16.8zm0-41v-9.3l-1.8 1.8-1.7-1.8-1.7 1.8-1.7-1.8-1.7 1.8-1.7-1.8-1.7 1.8-1.7-1.8-1.8 1.8v24.3l15.5-16.8zm20.5 0v-9.3l1.8 1.8 1.7-1.8 1.7 1.8 1.7-1.8 1.7 1.8 1.7-1.8 1.7 1.8 1.8-1.8 1.7 1.8v24.3l-15.5-16.8zm-49.7 35.4-1.7-1.9-1.7 2-1.7-2-1.7 2-1.7-2-1.8 2-1.7-2-1.7 2v-30l1.7 2 1.7-2 1.8 2 1.7-2 1.7 2 1.7-2 1.7 2 1.7-2v11.3h-6.8l-3.5 3.7 3.5 3.7h6.8v11.2zm78.9 0 1.7-1.9 1.7 2 1.7-2 1.8 2 1.7-2 1.7 2 1.7-2 1.7 2v-30l-1.7 2-1.7-2-1.7 2-1.7-2-1.8 2-1.7-2-1.7 2-1.7-2v11.3h6.9l3.4 3.7-3.4 3.7h-6.9v11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-91.4 156s-1.4 1.4-1.4 2.2c0 .7 1.5 2.2 2.2 2.2.8 0 2.1-1.5 2.1-2.2s-1.4-2.2-1.4-2.2v-3s3 5.1 3 2.9c0-1.6-3-4.3-3-4.3h-1.5s-3 3.2-3 4.3c0 2.2 3-2.9 3-2.9v3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M-73.5 161.7s-1.7 2-1.7 3 1.8 3.2 2.6 3.2c1 0 2.5-2.1 2.5-3.1s-1.7-3.1-1.7-3.1v-4.2s3 6.8 3 3.7c0-2-3-5.7-3-5.7h-1.7s-3.5 4.6-3 5.7c0 3.1 3-3.7 3-3.7v4.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.9,
    cy: 391.5,
    fill: "#00843d",
    rx: 3.5,
    ry: 1.8,
    transform: "matrix(.96774 0 0 1.0526 -482.4 -277.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.9,
    cy: 391.5,
    fill: "#00843d",
    rx: 3.5,
    ry: 1.8,
    transform: "matrix(.96774 0 0 1.0526 -463.5 -277.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.9,
    cy: 391.5,
    fill: "#00843d",
    rx: 3.5,
    ry: 1.8,
    transform: "matrix(.96774 0 0 1.0526 -444.7 -277.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-91.7 112.8s-1.4-1.5-1.4-2.2c0-.7 1.5-2.3 2.1-2.3.8 0 2.1 1.5 2.1 2.2 0 .8-1.4 2.3-1.4 2.3v3s3.1-5.2 3.1-3c0 1.6-3 4.4-3 4.4h-1.5s-3.1-3.2-3.1-4.3c0-2.2 3 2.8 3 2.8v-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M-73.9 107s-1.7-2-1.7-3 1.9-3.1 2.6-3.1c1 0 2.6 2 2.6 3s-1.7 3.2-1.7 3.2v4s3-6.7 3-3.6c0 2-3 5.8-3 5.8H-74s-3.5-4.7-3-5.8c0-3 3 3.7 3 3.7V107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-54.9 156s-1.4 1.4-1.4 2.2c0 .7 1.5 2.2 2.2 2.2.8 0 2.1-1.5 2.1-2.2s-1.4-2.2-1.4-2.2v-3s3 5.1 3 2.9c0-1.6-3-4.3-3-4.3H-55s-3 3.2-3 4.3c0 2.2 3-2.9 3-2.9v3zm-.3-43.2s-1.4-1.5-1.4-2.3c0-.6 1.5-2.2 2.1-2.2.8 0 2.1 1.5 2.1 2.2 0 .8-1.4 2.3-1.4 2.3v3s3.1-5.2 3.1-3c0 1.6-3 4.4-3 4.4h-1.5s-3.1-3.2-3.1-4.3c0-2.2 3 2.8 3 2.8v-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M-106.3 145.6s-1.9 1.4-1.9 2c0 .7 2 2.2 2.9 2.1 1 0 2.8-1.3 2.8-2s-1.9-2.1-1.9-2.1v-2.8s3.4 4.5 3.4 2.5c0-1.4-3.4-3.9-3.4-3.9h-1.9s-3.9 3.2-3.3 3.9c0 2 3.3-2.5 3.3-2.5v2.8zm-.4-21.1s-1.9-1.4-1.9-2.1c0-.7 2-2.1 2.9-2 1 0 2.8 1.3 2.8 2s-1.9 2-1.9 2v2.8s3.4-4.5 3.4-2.4c0 1.3-3.4 3.8-3.4 3.8h-1.9s-3.9-3.1-3.3-3.8c0-2 3.3 2.4 3.3 2.4v-2.7zm66.3 20.6s-2 1.4-2 2.1c0 .7 2.1 2.1 3 2.1 1 0 2.8-1.4 2.8-2 0-.8-2-2.2-2-2.2v-2.7s3.4 4.5 3.4 2.4c0-1.3-3.3-3.8-3.3-3.8h-2s-3.8 3.1-3.3 3.8c0 2.1 3.4-2.4 3.4-2.4v2.8zm-.4-21s-2-1.4-2-2.1c0-.7 2.1-2.1 3-2.1 1 0 2.8 1.4 2.8 2 0 .8-2 2.1-2 2.1v2.8s3.4-4.5 3.4-2.5c0 1.4-3.3 3.9-3.3 3.9h-2s-3.8-3.1-3.3-3.8c0-2.1 3.4 2.4 3.4 2.4V124z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-120.3 145.4c-.6-1.3-.4-1.9-.4-2.6 0-.7 1.7-2 2.3-2 .8 0 2.1 1.4 2.1 2.2 0 .7 0 1.3-.3 2.6l-.8-2.1c-1.1 3-1.2 3-1.8-.1l-1 2zm0-21.5c-.5 1.3-.4 1.9-.4 2.6 0 .7 1.7 2 2.4 2 .8 0 2.1-1.4 2.1-2.2 0-.7 0-1.3-.3-2.6l-.9 2.1c-1-3-1.1-3-1.8.1l-1-2zm92.5 21.2c-.6-1.3-.5-1.9-.5-2.6 0-.7 1.8-2 2.4-2 .8 0 2.1 1.5 2.1 2.2 0 .7 0 1.4-.3 2.6l-.9-2.1c-1 3-1.1 3.1-1.8 0l-1 1.9zm0-21.4c-.6 1.2-.4 1.8-.4 2.6 0 .6 1.7 2 2.3 2 .8 0 2.2-1.5 2.2-2.2 0-.8 0-1.4-.3-2.7l-1 2.2c-1-3.1-1-3.2-1.7 0l-1-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M115.2 177.2v-5.4h-16v-10.6H85v-3.5H72.6v-32H85v-3.5h14.2v-10.6h16v-5.3h21.2v5.3h16v10.6h14.1v3.6H179v31.9h-12.4v3.5h-14.1v10.6h-16v5.3h-21.2zm-1.8 1.7v-5.3h-16V163H83.3v-3.6H70.9V124h12.4v-3.5h14.1v-10.7h16v-5.3h24.8v5.3h16v10.7h14.1v3.5h12.4v35.4h-12.4v3.6h-14.2v10.6h-16v5.3h-24.7z",
    transform: "matrix(1 0 0 .99999 -198.4 -7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTm);
export default __webpack_public_path__ + "static/media/tm.d3ba1e6d.svg";
export { ForwardRef as ReactComponent };